import * as React from 'react';

function IconCheckInCircle(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_743_18456)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.339 8.512l-4.653 4.653a.837.837 0 01-1.179 0L5.661 10.32A.832.832 0 116.839 9.14l2.257 2.257 4.065-4.064a.833.833 0 011.178 1.178M9.999.833a9.167 9.167 0 100 18.334A9.167 9.167 0 0010 .833z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_743_18456">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconCheckInCircle = React.memo(IconCheckInCircle);
export default MemoIconCheckInCircle;
